import endpoint from "../../config/endpoints";

export const PlaceOrderTableJson = {
  showSaveNextBtn: true,
  showAddButton: true,
  apiBaseURL: endpoint.area,
  screenTitle: " Purchase Order ",
  formPath: "/placed-order-form",
  formPathView: "/place-order-view",
  deleteURL: endpoint.adminDashboard + "/by-is-bill-generate",

  tableColumnsToFilter: [
    {
      columnDisplayName: "Order No",
      columnKeyName: "orderNo",
      isChecked: true,
    },
    {
      columnDisplayName: "Order Date",
      columnKeyName: "orderDate",
      isChecked: true,
    },
    {
      columnDisplayName: "Total Quantity",
      columnKeyName: "totalQty",
      isChecked: true,
    },

    {
      columnDisplayName: "Total Amount",
      columnKeyName: "totalAmt",
      isChecked: true,
    },
    {
      columnDisplayName: "Status",
      columnKeyName: "statusName",
      isChecked: true,
    },
  ],

  searchList: [
    {
      label: "From Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 4,
      lg: 4,
      sm: 4,
      xs: 12,
      dataKey: "fromdate",
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "todate-le",
    },
    {
      label: "To Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 4,
      lg: 4,
      sm: 4,
      xs: 12,
      dataKey: "todate",
      onSubmit: "compare",
      onSubmitParameter: "fromdate-ge",
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "fromdate-ge",
    },
  ],
  fieldMeta: [],
};
